/* src/components/ZoomableMap/ZoomableMap.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_flush_callback,
	append_hydration,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_svg_element,
	claim_text,
	component_subscribe,
	create_component,
	destroy_block,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	noop,
	null_to_empty,
	run_all,
	safe_not_equal,
	set_data,
	set_store_value,
	set_style,
	space,
	svg_element,
	text,
	transition_in,
	transition_out,
	update_keyed_each
} from "svelte/internal";

import Tabs from '../Tabs/Tabs.svelte';
import { spring } from 'svelte/motion';
import { onMount } from 'svelte';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';
import Icon from '../Icon/Icon.svelte';
import StatePath from './components/StatePath/StatePath.svelte';
import gql from 'nanographql';

import {
	formatRate,
	roundFormat,
	roundToMax2Decimals
} from '../../helpers/svelte/utils/formatters';

import EmbedModal from '../EmbedModal/EmbedModal.svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[51] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[54] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[57] = list[i];
	child_ctx[59] = i;
	return child_ctx;
}

// (213:2) {#if hoveredEntity}
function create_if_block_6(ctx) {
	let div2;
	let div1;
	let div0;
	let t0;
	let t1;
	let div2_style_value;

	function select_block_type(ctx, dirty) {
		if (/*hoveredEntity*/ ctx[16].stateName) return create_if_block_13;
		return create_else_block_1;
	}

	let current_block_type = select_block_type(ctx, [-1, -1]);
	let if_block0 = current_block_type(ctx);
	let if_block1 = /*hoveredEntity*/ ctx[16] && (/*hoveredEntity*/ ctx[16][/*selectedDataPoint*/ ctx[0].property] || /*hoveredEntity*/ ctx[16][/*selectedDataPoint*/ ctx[0].property] === 0) && create_if_block_12(ctx);
	let if_block2 = /*hoveredEntity*/ ctx[16] && (/*hoveredEntity*/ ctx[16].providers_count >= 0 || /*hoveredEntity*/ ctx[16].plants_count >= 0 || /*hoveredEntity*/ ctx[16].providerCount >= 0 || /*hoveredEntity*/ ctx[16].plantsCount >= 0) && create_if_block_7(ctx);

	return {
		c() {
			div2 = element("div");
			div1 = element("div");
			div0 = element("div");
			if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			this.h();
		},
		l(nodes) {
			div2 = claim_element(nodes, "DIV", { style: true, class: true });
			var div2_nodes = children(div2);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			if_block0.l(div0_nodes);
			t0 = claim_space(div0_nodes);
			if (if_block1) if_block1.l(div0_nodes);
			div0_nodes.forEach(detach);
			t1 = claim_space(div1_nodes);
			if (if_block2) if_block2.l(div1_nodes);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "overall-score-description align-self-center mb-1 text-center text-body svelte-7v0gex");
			attr(div1, "class", "row overall-score justify-content-around pb-2 mx-1 flex-column");
			attr(div2, "style", div2_style_value = `position:absolute; top:${/*hoverY*/ ctx[18] + 18}px; left:${/*hoverX*/ ctx[17] - 160}px;`);
			attr(div2, "class", "tiny-report-card d-flex flex-column bg-white border p-1 rounded shadow svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div2, anchor);
			append_hydration(div2, div1);
			append_hydration(div1, div0);
			if_block0.m(div0, null);
			append_hydration(div0, t0);
			if (if_block1) if_block1.m(div0, null);
			append_hydration(div1, t1);
			if (if_block2) if_block2.m(div1, null);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block0) {
				if_block0.p(ctx, dirty);
			} else {
				if_block0.d(1);
				if_block0 = current_block_type(ctx);

				if (if_block0) {
					if_block0.c();
					if_block0.m(div0, t0);
				}
			}

			if (/*hoveredEntity*/ ctx[16] && (/*hoveredEntity*/ ctx[16][/*selectedDataPoint*/ ctx[0].property] || /*hoveredEntity*/ ctx[16][/*selectedDataPoint*/ ctx[0].property] === 0)) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_12(ctx);
					if_block1.c();
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*hoveredEntity*/ ctx[16] && (/*hoveredEntity*/ ctx[16].providers_count >= 0 || /*hoveredEntity*/ ctx[16].plants_count >= 0 || /*hoveredEntity*/ ctx[16].providerCount >= 0 || /*hoveredEntity*/ ctx[16].plantsCount >= 0)) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_7(ctx);
					if_block2.c();
					if_block2.m(div1, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (dirty[0] & /*hoverY, hoverX*/ 393216 && div2_style_value !== (div2_style_value = `position:absolute; top:${/*hoverY*/ ctx[18] + 18}px; left:${/*hoverX*/ ctx[17] - 160}px;`)) {
				attr(div2, "style", div2_style_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div2);
			if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
		}
	};
}

// (223:10) {:else}
function create_else_block_1(ctx) {
	let t0_value = /*hoveredEntity*/ ctx[16].name + "";
	let t0;
	let t1;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(":");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, ":");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 65536 && t0_value !== (t0_value = /*hoveredEntity*/ ctx[16].name + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
		}
	};
}

// (220:10) {#if hoveredEntity.stateName}
function create_if_block_13(ctx) {
	let t0_value = /*hoveredEntity*/ ctx[16].name + "";
	let t0;
	let t1;
	let t2_value = /*hoveredEntity*/ ctx[16].stateName + "";
	let t2;
	let t3;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text(",\n            ");
			t2 = text(t2_value);
			t3 = text(":");
		},
		l(nodes) {
			t0 = claim_text(nodes, t0_value);
			t1 = claim_text(nodes, ",\n            ");
			t2 = claim_text(nodes, t2_value);
			t3 = claim_text(nodes, ":");
		},
		m(target, anchor) {
			insert_hydration(target, t0, anchor);
			insert_hydration(target, t1, anchor);
			insert_hydration(target, t2, anchor);
			insert_hydration(target, t3, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 65536 && t0_value !== (t0_value = /*hoveredEntity*/ ctx[16].name + "")) set_data(t0, t0_value);
			if (dirty[0] & /*hoveredEntity*/ 65536 && t2_value !== (t2_value = /*hoveredEntity*/ ctx[16].stateName + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(t3);
		}
	};
}

// (225:10) {#if hoveredEntity && (hoveredEntity[selectedDataPoint.property] || hoveredEntity[selectedDataPoint.property] === 0)}
function create_if_block_12(ctx) {
	let div;
	let t_value = /*FORMATTERS*/ ctx[32][/*selectedDataPoint*/ ctx[0].property](/*hoveredEntity*/ ctx[16]) + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, t_value);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "overall-score-count svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*selectedDataPoint, hoveredEntity*/ 65537 && t_value !== (t_value = /*FORMATTERS*/ ctx[32][/*selectedDataPoint*/ ctx[0].property](/*hoveredEntity*/ ctx[16]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (232:8) {#if hoveredEntity && (hoveredEntity.providers_count >= 0 || hoveredEntity.plants_count >= 0 || hoveredEntity.providerCount >= 0 || hoveredEntity.plantsCount >= 0)}
function create_if_block_7(ctx) {
	let div;
	let t;

	function select_block_type_1(ctx, dirty) {
		if (/*hoveredEntity*/ ctx[16].providers_count >= 0) return create_if_block_10;
		if (/*hoveredEntity*/ ctx[16].providerCount >= 0) return create_if_block_11;
	}

	let current_block_type = select_block_type_1(ctx, [-1, -1]);
	let if_block0 = current_block_type && current_block_type(ctx);

	function select_block_type_2(ctx, dirty) {
		if (/*hoveredEntity*/ ctx[16].plants_count >= 0) return create_if_block_8;
		if (/*hoveredEntity*/ ctx[16].plantsCount >= 0) return create_if_block_9;
	}

	let current_block_type_1 = select_block_type_2(ctx, [-1, -1]);
	let if_block1 = current_block_type_1 && current_block_type_1(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if (if_block0) if_block0.l(div_nodes);
			t = claim_space(div_nodes);
			if (if_block1) if_block1.l(div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "border-top pt-2");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append_hydration(div, t);
			if (if_block1) if_block1.m(div, null);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block0) {
				if_block0.p(ctx, dirty);
			} else {
				if (if_block0) if_block0.d(1);
				if_block0 = current_block_type && current_block_type(ctx);

				if (if_block0) {
					if_block0.c();
					if_block0.m(div, t);
				}
			}

			if (current_block_type_1 === (current_block_type_1 = select_block_type_2(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if (if_block1) if_block1.d(1);
				if_block1 = current_block_type_1 && current_block_type_1(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);

			if (if_block0) {
				if_block0.d();
			}

			if (if_block1) {
				if_block1.d();
			}
		}
	};
}

// (236:55) 
function create_if_block_11(ctx) {
	let div;
	let t0_value = /*hoveredEntity*/ ctx[16].providerCount.toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text(t0_value);
			t1 = text(" Providers");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, t0_value);
			t1 = claim_text(div_nodes, " Providers");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "overall-score-count svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t0);
			append_hydration(div, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 65536 && t0_value !== (t0_value = /*hoveredEntity*/ ctx[16].providerCount.toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (234:12) {#if hoveredEntity.providers_count >= 0}
function create_if_block_10(ctx) {
	let div;
	let t0_value = /*hoveredEntity*/ ctx[16].providers_count.toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text(t0_value);
			t1 = text(" Providers");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, t0_value);
			t1 = claim_text(div_nodes, " Providers");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "overall-score-count svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t0);
			append_hydration(div, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 65536 && t0_value !== (t0_value = /*hoveredEntity*/ ctx[16].providers_count.toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (242:53) 
function create_if_block_9(ctx) {
	let div;
	let t0_value = /*hoveredEntity*/ ctx[16].plantsCount.toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text(t0_value);
			t1 = text(" Plants");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, t0_value);
			t1 = claim_text(div_nodes, " Plants");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "overall-score-count svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t0);
			append_hydration(div, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 65536 && t0_value !== (t0_value = /*hoveredEntity*/ ctx[16].plantsCount.toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (240:12) {#if hoveredEntity.plants_count >= 0}
function create_if_block_8(ctx) {
	let div;
	let t0_value = /*hoveredEntity*/ ctx[16].plants_count.toLocaleString() + "";
	let t0;
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text(t0_value);
			t1 = text(" Plants");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, t0_value);
			t1 = claim_text(div_nodes, " Plants");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "overall-score-count svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t0);
			append_hydration(div, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*hoveredEntity*/ 65536 && t0_value !== (t0_value = /*hoveredEntity*/ ctx[16].plants_count.toLocaleString() + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (250:2) {#if selected}
function create_if_block_5(ctx) {
	let div;
	let icon;
	let t;
	let current;
	let mounted;
	let dispose;
	icon = new Icon({ props: { icon: "compress" } });

	return {
		c() {
			div = element("div");
			create_component(icon.$$.fragment);
			t = text("\n      Zoom Out");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(icon.$$.fragment, div_nodes);
			t = claim_text(div_nodes, "\n      Zoom Out");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "zoom-out svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(icon, div, null);
			append_hydration(div, t);
			current = true;

			if (!mounted) {
				dispose = listen(div, "click", /*click_handler*/ ctx[36]);
				mounted = true;
			}
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(icon);
			mounted = false;
			dispose();
		}
	};
}

// (265:10) {#each counties as county, i (county)}
function create_each_block_2(key_1, ctx) {
	let path;
	let path_d_value;
	let path_class_value;
	let mounted;
	let dispose;

	function mouseover_handler(...args) {
		return /*mouseover_handler*/ ctx[37](/*county*/ ctx[57], ...args);
	}

	function click_handler_1() {
		return /*click_handler_1*/ ctx[38](/*county*/ ctx[57]);
	}

	return {
		key: key_1,
		first: null,
		c() {
			path = svg_element("path");
			this.h();
		},
		l(nodes) {
			path = claim_svg_element(nodes, "path", { d: true, class: true });
			children(path).forEach(detach);
			this.h();
		},
		h() {
			attr(path, "d", path_d_value = /*county*/ ctx[57].svgPath);

			attr(path, "class", path_class_value = "" + (null_to_empty(`${typeof /*county*/ ctx[57][/*selectedDataPoint*/ ctx[0].property] !== 'undefined'
			? /*getPercentileClass*/ ctx[23]('fill', /*county*/ ctx[57][/*selectedDataPoint*/ ctx[0].property])
			: 'no-data'}`) + " svelte-7v0gex"));

			this.first = path;
		},
		m(target, anchor) {
			insert_hydration(target, path, anchor);

			if (!mounted) {
				dispose = [
					listen(path, "mouseover", mouseover_handler),
					listen(path, "click", click_handler_1)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*counties*/ 524288 && path_d_value !== (path_d_value = /*county*/ ctx[57].svgPath)) {
				attr(path, "d", path_d_value);
			}

			if (dirty[0] & /*counties, selectedDataPoint*/ 524289 && path_class_value !== (path_class_value = "" + (null_to_empty(`${typeof /*county*/ ctx[57][/*selectedDataPoint*/ ctx[0].property] !== 'undefined'
			? /*getPercentileClass*/ ctx[23]('fill', /*county*/ ctx[57][/*selectedDataPoint*/ ctx[0].property])
			: 'no-data'}`) + " svelte-7v0gex"))) {
				attr(path, "class", path_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(path);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (298:12) {:else}
function create_else_block(ctx) {
	let statepath;
	let current;

	function clicked_handler_1(...args) {
		return /*clicked_handler_1*/ ctx[40](/*state*/ ctx[54], ...args);
	}

	function hovered_handler(...args) {
		return /*hovered_handler*/ ctx[41](/*state*/ ctx[54], ...args);
	}

	statepath = new StatePath({
			props: {
				state: /*state*/ ctx[54],
				classes: `${typeof /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property] !== 'undefined'
				? /*getPercentileClass*/ ctx[23]('fill', /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property])
				: 'no-data'}`
			}
		});

	statepath.$on("clicked", clicked_handler_1);
	statepath.$on("hovered", hovered_handler);

	return {
		c() {
			create_component(statepath.$$.fragment);
		},
		l(nodes) {
			claim_component(statepath.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(statepath, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const statepath_changes = {};
			if (dirty[0] & /*states*/ 2) statepath_changes.state = /*state*/ ctx[54];

			if (dirty[0] & /*states, selectedDataPoint*/ 3) statepath_changes.classes = `${typeof /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property] !== 'undefined'
			? /*getPercentileClass*/ ctx[23]('fill', /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property])
			: 'no-data'}`;

			statepath.$set(statepath_changes);
		},
		i(local) {
			if (current) return;
			transition_in(statepath.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(statepath.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(statepath, detaching);
		}
	};
}

// (284:12) {#if state.slug === selected}
function create_if_block_4(ctx) {
	let statepath;
	let current;

	function clicked_handler(...args) {
		return /*clicked_handler*/ ctx[39](/*state*/ ctx[54], ...args);
	}

	statepath = new StatePath({
			props: {
				selected: "true",
				state: /*state*/ ctx[54],
				classes: `${typeof /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property] !== 'undefined'
				? /*getPercentileClass*/ ctx[23]('fill', /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property])
				: 'no-data'}${' bb-set'} active`
			}
		});

	statepath.$on("updateZoom", /*updateZoom*/ ctx[28]);
	statepath.$on("clicked", clicked_handler);

	return {
		c() {
			create_component(statepath.$$.fragment);
		},
		l(nodes) {
			claim_component(statepath.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(statepath, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const statepath_changes = {};
			if (dirty[0] & /*states*/ 2) statepath_changes.state = /*state*/ ctx[54];

			if (dirty[0] & /*states, selectedDataPoint*/ 3) statepath_changes.classes = `${typeof /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property] !== 'undefined'
			? /*getPercentileClass*/ ctx[23]('fill', /*state*/ ctx[54][/*selectedDataPoint*/ ctx[0].property])
			: 'no-data'}${' bb-set'} active`;

			statepath.$set(statepath_changes);
		},
		i(local) {
			if (current) return;
			transition_in(statepath.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(statepath.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(statepath, detaching);
		}
	};
}

// (283:10) {#each states as state}
function create_each_block_1(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_4, create_else_block];
	const if_blocks = [];

	function select_block_type_3(ctx, dirty) {
		if (/*state*/ ctx[54].slug === /*selected*/ ctx[15]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_3(ctx, [-1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_3(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (506:2) {#if showSidepane}
function create_if_block_2(ctx) {
	let section;
	let h2;
	let t0;
	let t1;
	let t2;
	let t3;
	let div;
	let t4;
	let p;
	let t5_value = (/*disableStateZoom*/ ctx[10] ? 'Hover' : 'Click') + "";
	let t5;
	let t6;
	let t7;
	let ul;
	let t8;
	let li;
	let span;
	let t9;
	let if_block = /*selectedDataPoint*/ ctx[0].description && create_if_block_3(ctx);
	let each_value = /*selectedDataPoint*/ ctx[0].colorTags;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			t0 = text(/*activeTab*/ ctx[13]);
			t1 = text(" in the US");
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			div = element("div");
			t4 = space();
			p = element("p");
			t5 = text(t5_value);
			t6 = text(" on a state to see more details.");
			t7 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t8 = space();
			li = element("li");
			span = element("span");
			t9 = text("\n          No data available");
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { class: true });
			var section_nodes = children(section);
			h2 = claim_element(section_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, /*activeTab*/ ctx[13]);
			t1 = claim_text(h2_nodes, " in the US");
			h2_nodes.forEach(detach);
			t2 = claim_space(section_nodes);
			if (if_block) if_block.l(section_nodes);
			t3 = claim_space(section_nodes);
			div = claim_element(section_nodes, "DIV", { class: true });
			children(div).forEach(detach);
			t4 = claim_space(section_nodes);
			p = claim_element(section_nodes, "P", { class: true });
			var p_nodes = children(p);
			t5 = claim_text(p_nodes, t5_value);
			t6 = claim_text(p_nodes, " on a state to see more details.");
			p_nodes.forEach(detach);
			t7 = claim_space(section_nodes);
			ul = claim_element(section_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			t8 = claim_space(ul_nodes);
			li = claim_element(ul_nodes, "LI", { class: true });
			var li_nodes = children(li);
			span = claim_element(li_nodes, "SPAN", { class: true });
			children(span).forEach(detach);
			t9 = claim_text(li_nodes, "\n          No data available");
			li_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "sidepane__title h4 svelte-7v0gex");
			attr(div, "class", "sidepane__separator svelte-7v0gex");
			attr(p, "class", "sidepane__instructions");
			attr(span, "class", "no-data svelte-7v0gex");
			attr(li, "class", "svelte-7v0gex");
			attr(ul, "class", "sidepane__colors svelte-7v0gex");
			attr(section, "class", "sidepane svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, section, anchor);
			append_hydration(section, h2);
			append_hydration(h2, t0);
			append_hydration(h2, t1);
			append_hydration(section, t2);
			if (if_block) if_block.m(section, null);
			append_hydration(section, t3);
			append_hydration(section, div);
			append_hydration(section, t4);
			append_hydration(section, p);
			append_hydration(p, t5);
			append_hydration(p, t6);
			append_hydration(section, t7);
			append_hydration(section, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			append_hydration(ul, t8);
			append_hydration(ul, li);
			append_hydration(li, span);
			append_hydration(li, t9);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*activeTab*/ 8192) set_data(t0, /*activeTab*/ ctx[13]);

			if (/*selectedDataPoint*/ ctx[0].description) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(section, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty[0] & /*disableStateZoom*/ 1024 && t5_value !== (t5_value = (/*disableStateZoom*/ ctx[10] ? 'Hover' : 'Click') + "")) set_data(t5, t5_value);

			if (dirty[0] & /*selectedDataPoint, colorPrefix*/ 129) {
				each_value = /*selectedDataPoint*/ ctx[0].colorTags;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, t8);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(section);
			if (if_block) if_block.d();
			destroy_each(each_blocks, detaching);
		}
	};
}

// (511:6) {#if selectedDataPoint.description}
function create_if_block_3(ctx) {
	let p;
	let t_value = /*selectedDataPoint*/ ctx[0].description + "";
	let t;

	return {
		c() {
			p = element("p");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t = claim_text(p_nodes, t_value);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "sidepane__paragraph");
		},
		m(target, anchor) {
			insert_hydration(target, p, anchor);
			append_hydration(p, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*selectedDataPoint*/ 1 && t_value !== (t_value = /*selectedDataPoint*/ ctx[0].description + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (521:8) {#each selectedDataPoint.colorTags as tag}
function create_each_block(ctx) {
	let li;
	let span;
	let span_class_value;
	let t0;
	let t1_value = /*tag*/ ctx[51].text + "";
	let t1;

	return {
		c() {
			li = element("li");
			span = element("span");
			t0 = space();
			t1 = text(t1_value);
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			span = claim_element(li_nodes, "SPAN", { class: true });
			children(span).forEach(detach);
			t0 = claim_space(li_nodes);
			t1 = claim_text(li_nodes, t1_value);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", span_class_value = "" + (/*colorPrefix*/ ctx[7] + /*tag*/ ctx[51].color + "-bg" + " svelte-7v0gex"));
			attr(li, "class", "svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, span);
			append_hydration(li, t0);
			append_hydration(li, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*colorPrefix, selectedDataPoint*/ 129 && span_class_value !== (span_class_value = "" + (/*colorPrefix*/ ctx[7] + /*tag*/ ctx[51].color + "-bg" + " svelte-7v0gex"))) {
				attr(span, "class", span_class_value);
			}

			if (dirty[0] & /*selectedDataPoint*/ 1 && t1_value !== (t1_value = /*tag*/ ctx[51].text + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (535:2) {#if nationalInfo}
function create_if_block_1(ctx) {
	let div;
	let span;
	let t0;
	let t1;
	let strong;
	let t2_value = /*nationalFormatters*/ ctx[33][/*selectedDataPoint*/ ctx[0].property](/*nationalInfo*/ ctx[6][/*selectedDataPoint*/ ctx[0].nationalValue]) + "";
	let t2;

	return {
		c() {
			div = element("div");
			span = element("span");
			t0 = text("National Average:");
			t1 = space();
			strong = element("strong");
			t2 = text(t2_value);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			span = claim_element(div_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, "National Average:");
			span_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			strong = claim_element(div_nodes, "STRONG", {});
			var strong_nodes = children(strong);
			t2 = claim_text(strong_nodes, t2_value);
			strong_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "svelte-7v0gex");
			attr(div, "class", "average-data svelte-7v0gex");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, span);
			append_hydration(span, t0);
			append_hydration(div, t1);
			append_hydration(div, strong);
			append_hydration(strong, t2);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*selectedDataPoint, nationalInfo*/ 65 && t2_value !== (t2_value = /*nationalFormatters*/ ctx[33][/*selectedDataPoint*/ ctx[0].property](/*nationalInfo*/ ctx[6][/*selectedDataPoint*/ ctx[0].nationalValue]) + "")) set_data(t2, t2_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (542:0) {#if componentEmbedId || debugEmbedId}
function create_if_block(ctx) {
	let embedmodal;
	let updating_isModalOpen;
	let current;

	function embedmodal_isModalOpen_binding(value) {
		/*embedmodal_isModalOpen_binding*/ ctx[43](value);
	}

	let embedmodal_props = {
		componentEmbedId: /*componentEmbedId*/ ctx[12] || debugEmbedId,
		buttonClasses: "margin-top"
	};

	if (/*isModalOpen*/ ctx[14] !== void 0) {
		embedmodal_props.isModalOpen = /*isModalOpen*/ ctx[14];
	}

	embedmodal = new EmbedModal({ props: embedmodal_props });
	binding_callbacks.push(() => bind(embedmodal, 'isModalOpen', embedmodal_isModalOpen_binding));

	return {
		c() {
			create_component(embedmodal.$$.fragment);
		},
		l(nodes) {
			claim_component(embedmodal.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(embedmodal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const embedmodal_changes = {};
			if (dirty[0] & /*componentEmbedId*/ 4096) embedmodal_changes.componentEmbedId = /*componentEmbedId*/ ctx[12] || debugEmbedId;

			if (!updating_isModalOpen && dirty[0] & /*isModalOpen*/ 16384) {
				updating_isModalOpen = true;
				embedmodal_changes.isModalOpen = /*isModalOpen*/ ctx[14];
				add_flush_callback(() => updating_isModalOpen = false);
			}

			embedmodal.$set(embedmodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(embedmodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(embedmodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(embedmodal, detaching);
		}
	};
}

function create_fragment(ctx) {
	let tabs;
	let updating_activeTab;
	let t0;
	let div1;
	let t1;
	let t2;
	let div0;
	let svg;
	let rect;
	let g2;
	let g0;
	let each_blocks_1 = [];
	let each0_lookup = new Map();
	let g1;
	let path0;
	let path0_style_value;
	let g2_style_value;
	let g2_transform_value;
	let pattern;
	let path1;
	let svg_viewBox_value;
	let t3;
	let t4;
	let div1_class_value;
	let t5;
	let if_block4_anchor;
	let current;
	let mounted;
	let dispose;

	function tabs_activeTab_binding(value) {
		/*tabs_activeTab_binding*/ ctx[35](value);
	}

	let tabs_props = {
		items: /*dataPoints*/ ctx[5].map(func),
		customClass: /*customTabClass*/ ctx[8]
	};

	if (/*activeTab*/ ctx[13] !== void 0) {
		tabs_props.activeTab = /*activeTab*/ ctx[13];
	}

	tabs = new Tabs({ props: tabs_props });
	binding_callbacks.push(() => bind(tabs, 'activeTab', tabs_activeTab_binding));
	let if_block0 = /*hoveredEntity*/ ctx[16] && create_if_block_6(ctx);
	let if_block1 = /*selected*/ ctx[15] && create_if_block_5(ctx);
	let each_value_2 = /*counties*/ ctx[19];
	const get_key = ctx => /*county*/ ctx[57];

	for (let i = 0; i < each_value_2.length; i += 1) {
		let child_ctx = get_each_context_2(ctx, each_value_2, i);
		let key = get_key(child_ctx);
		each0_lookup.set(key, each_blocks_1[i] = create_each_block_2(key, child_ctx));
	}

	let each_value_1 = /*states*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block2 = /*showSidepane*/ ctx[9] && create_if_block_2(ctx);
	let if_block3 = /*nationalInfo*/ ctx[6] && create_if_block_1(ctx);
	let if_block4 = (/*componentEmbedId*/ ctx[12] || debugEmbedId) && create_if_block(ctx);

	return {
		c() {
			create_component(tabs.$$.fragment);
			t0 = space();
			div1 = element("div");
			if (if_block0) if_block0.c();
			t1 = space();
			if (if_block1) if_block1.c();
			t2 = space();
			div0 = element("div");
			svg = svg_element("svg");
			rect = svg_element("rect");
			g2 = svg_element("g");
			g0 = svg_element("g");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			g1 = svg_element("g");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			path0 = svg_element("path");
			pattern = svg_element("pattern");
			path1 = svg_element("path");
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			if (if_block3) if_block3.c();
			t5 = space();
			if (if_block4) if_block4.c();
			if_block4_anchor = empty();
			this.h();
		},
		l(nodes) {
			claim_component(tabs.$$.fragment, nodes);
			t0 = claim_space(nodes);
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			if (if_block0) if_block0.l(div1_nodes);
			t1 = claim_space(div1_nodes);
			if (if_block1) if_block1.l(div1_nodes);
			t2 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", {});
			var div0_nodes = children(div0);

			svg = claim_svg_element(div0_nodes, "svg", {
				xmlns: true,
				width: true,
				height: true,
				viewBox: true,
				class: true
			});

			var svg_nodes = children(svg);

			rect = claim_svg_element(svg_nodes, "rect", {
				class: true,
				width: true,
				height: true,
				d: true
			});

			children(rect).forEach(detach);
			g2 = claim_svg_element(svg_nodes, "g", { style: true, transform: true });
			var g2_nodes = children(g2);
			g0 = claim_svg_element(g2_nodes, "g", { id: true, class: true });
			var g0_nodes = children(g0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(g0_nodes);
			}

			g0_nodes.forEach(detach);
			g1 = claim_svg_element(g2_nodes, "g", { id: true });
			var g1_nodes = children(g1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(g1_nodes);
			}

			g1_nodes.forEach(detach);

			path0 = claim_svg_element(g2_nodes, "path", {
				id: true,
				style: true,
				d: true,
				class: true
			});

			children(path0).forEach(detach);
			g2_nodes.forEach(detach);

			pattern = claim_svg_element(svg_nodes, "pattern", {
				id: true,
				patternUnits: true,
				width: true,
				height: true,
				style: true
			});

			var pattern_nodes = children(pattern);
			path1 = claim_svg_element(pattern_nodes, "path", { d: true, style: true });
			children(path1).forEach(detach);
			pattern_nodes.forEach(detach);
			svg_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t3 = claim_space(div1_nodes);
			if (if_block2) if_block2.l(div1_nodes);
			t4 = claim_space(div1_nodes);
			if (if_block3) if_block3.l(div1_nodes);
			div1_nodes.forEach(detach);
			t5 = claim_space(nodes);
			if (if_block4) if_block4.l(nodes);
			if_block4_anchor = empty();
			this.h();
		},
		h() {
			attr(rect, "class", "background svelte-7v0gex");
			attr(rect, "width", /*width*/ ctx[4]);
			attr(rect, "height", /*height*/ ctx[3]);
			attr(rect, "d", "M0 0h960v500H0z");
			attr(g0, "id", "counties");
			attr(g0, "class", "svelte-7v0gex");
			attr(g1, "id", "states");
			attr(path0, "id", "state-borders");

			attr(path0, "style", path0_style_value = /*mapStrokeColor*/ ctx[11]
			? `stroke: ${/*mapStrokeColor*/ ctx[11]};`
			: '');

			attr(path0, "d", "M598.907 124.82l-1.804-1.646.994-2.696-3.173-.067\n          1.027-2.878-.666-1.161.534-1.999-.92-.846-2.843-.845h0l-1.088-.674.125-1.88-5.214-1.377-2.272.238-3.336-.852-.777-.395-1.356-.673-11.008-2.258.015.23-.015-.23-2.544-.531-1.391-2.992-2.656-1.023M140.862\n          59.559l1.144.065 2.233 2.645.267 4.605-.414 2.27-.2 1.538 1.19 1.116 4.576 2.434 4.578-.68 1.775-.608\n          3.702.67.813.754 2.787 1.353.523 1.296 1.559-.555 1.551.729 3.722-.865 1.97 1.34 3.536.367 3.133-.897 1.782.014\n          2.588.258 1.492-.945 1.776.593 3.87.689 2.113-.767 12.515 2.997.227.054 4.761 1.142 1.54.375 7.127 1.678m263.446\n          76.439l.032-6.549h0l.03-6.513.032-6.489.055-1.649.016-3.266-.033-3.206.026-5.442-.23-1.075-2.768-1.602-1.947-3.286-.131-1.034\n          2.31-1.747\n          1.227-1.766.152-1.943-8.635-.081-9.753-.175-.373-.008-9.33-.292-3.639-.13-9.328-.34-2.051-.103-8.251-.405-19.243-1.085-12.246-.835-.697-.062-13.585-1.077M105.56\n          130.611l5.14 1.624 4.013 1.086 3.852 1.1 12.473 3.512 11.138 3.329 7.527 2.103 11.728 3.053 8.525 2.2.48.12\n          15.103 3.626 15.722 3.576 6.928-30.801h0l.659-2.929.725-.59 1.095-1.808-.262-1.246\n          1.405-1.666-2.274-2.986-1.313-.7.71-3.345 1.005-.546 2.393-3.686 2.289-1.31 2.452-4.033 2.01-3.174 2.615-3.996\n          1.568-1.453-.401-2.767-2.828-2.811-.939-2.869-.465-1.972 1.046-1.264-.998-3.609.59-1.354.002-.01.47-2.088\n          2.391-10.624.537-2.385.438-1.946 2.487-11.05.28-1.242 3.295-14.435.618-2.746m596.098\n          93.127l-.165-1.72-3.103-2.18-.457-2.998-1.543-4.426h0l-.014-.048-2.673-8.82-2.78-8.864-3.141-9.327M784.599\n          95.94l.225 3.14 1.518 5.041.351.236 1.087 1.846.49 3.225-.66 1.538.518 3.158 1.32 3.814.43.953-.322 2.359.72\n          1.121.959-1.373 1.031 1.17.967 4.37 1.415 6.828 1.024 3.582 3.206-.692 1.242-.276\n          6.276-1.331-1.464-1.203-.381-2.91.79-1.053-.852-2.77-.095-1.37-.854-6.325.522-.694-.105-1.98.95-1.542.148-4.466.664-1.657-.464-1.419-.678-3.015\n          2.373-1.134.697-1.304 1.945-2.37.118-1.612-2.011-2.787.998-3.296-.576-1.812m-419.19-36.907l-.57 6.728-.383\n          4.51-.57 7.255-.94 11.066-.105 1.242-1.083 12.765-.158 1.863-.411 4.845-.527 6.206-.1 1.178-1.01 12.457-.575\n          3.992-12.865-1.22-.66-.064-12.305-1.11-3.107-.333-10.813-1.28-10.75-1.398-4.418-.524-4.878-.663-15.372-2.18-11.87-1.6-4.367-.873-1.176\n          6.162-.429 3.587-1.446 9.063-1.38 8.95-.547 3.424-.876 5.487-1.55 9.4-1.516 9.494-1.203 7.851-1.021 6.083-.753\n          4.714 13.782 2.146.694.104 13.12 1.818 15.722 2.047 8.318 1.001 6.375.768 7.473.897 1.794.204 12.727 1.308\n          4.645.447 12.398\n          1.05.624-7.345.273-3.214.213-2.508.483-5.688.97-11.421.625-7.36.703-8.855.041-.482.556-6.545.455-5.357.063-.743.62-7.287.628-7.955m98.816-13.034l-.13-1.614.242-1.55-.532-4.218-1.741-2.884-.58-2.704-.184-.012-.017-3.488.567-1.814-.95-1.696-.069-2.675.106-1.616-.23-4.869-.471-3.243-1.99-5.078-1.08-4.21.049-.347.32-4.19-.466-2.29.792-2.58-1.089-2.423-.446-3.455M282.174\n          171.452l-6.255-.974-8.204-1.325-.776-.154-11.3-2.002-14.117-2.54-3.254-.63-10.227-2.085-9.83-2.046-16.811-3.694-.139-.062m605.135-21.291l2.35-.493\n          4.736-1.04.382-.088 8.072-1.837.294-.8-.008-.028.11-.155 2.053-1.792.173-1.05 2.761-1.017m-31.527\n          24.025l-.144.035-.281-.535.16-8.34.145-4.586m-416.24 27.406l7.428.69 6.805.52 2.82.205 9.63.664 11.58.72\n          13.975.683 9.011.377 3.752.134 10.282.301 2.53 2.244 2.13.878v-.02l1.581 1.468 1.326-.205 1.403-1.728 2.729.383\n          2.05.064 2.4-.298 1.986 1.297 1.948.739 2.877 1.107 1.412 1.02.916 2.38 2.55.66-.73-1.326-1.74-3.967\n          1.237-2.585.405-2.641.782-.632-.231-2.431-1.113-.873.402-2.519-.956-2.011 1.935.01 5.42.015 2.566-.001\n          5.468-.03.92.005 6.388-.057.774-.02 5.565-.069 2.662-.046 3.726-.054 4.306-.1 2.08-.052 6.047-.174.29-.009\n          6.336-.234 1.451-.054 4.98-.206 4.69-.202 1.596-.073 5.317-.256.22 1.462-.043 1.082 2.187 1.907-1.432 3.406.38\n          1.708 1.607 4.605 2.166 1.088v.01l2.733.629.965 2.301 2.942-.149 6.862-.4 1.176-.077 5.984-.3.49-.025 5.787-.326\n          2.257-.11.928-.1 5.482-.454 1.467-.13 5.388-.404m182.5 19.302l.864-1.262\n          3.11-2.603-.003-.01-3.823-2.88-1.891-1.028-.668-2.287-1.875-.525-.167-.284-.35-3.198 1.285-2.09-1.329-1.57\n          1.535-2.78-.333.117.789-1.058.538-2.838\n          1.581-1.832-1.019-1.106-3.399-.34-1.613-1.96-.964-3.854-1.032-.525-1.636.178-1.963-2.226-1.587.38-8.42\n          1.787-.531.113-5.567 1.167-4.99 1.025-.534.109-8.682 1.732-1.882.429-6.18 1.124-1.36.257-8.307\n          1.598-1.908.284-7.441 1.38-2.101.333-.866-5.016M561.91 176.243l.042.746 2.4 1.511 1.251 2.82 1.071.564 2.148\n          1.175.304 1.722.168 1.933-.257 2.273-.86.559-.93 1.079-.197 2.543-1.611 1.421-4.402 1.576-3.5.835-.366\n          1.62v.02l-.458 1.775 1.727 1.408.738 1.622.001.03-.055 2.748-1.707 1.994-.178 2.42-1 1.166-2.289.692-.054\n          4.075-.645.274-4.384-3.959-3.182-.002-3.322.25-2.418.155-4.03.26-1.058.068-5.393.277-3.883.184-2.573.068-3.076.126-3.38.146-3.026.1-3.381.09-2.221.013-3.988-.02-4.039-.03-2.422-.012-5.502-.066-1.719-2.557.754-1.185.247-2.206-.908-2.861-.05-.06.048-1.953-.602-.575.698-1.842-.9-1.93-.848-2.183-1.345-.567-.395-2.75.797-2.223-.99-1.213.102-2.041-1.976-1.378.103-1.243-1.228-1.913.005-1.161-.832-1.336.5-1.725-.88-.953m347.494-26.255l-.934-2.91-.94-.052m-166.851\n          32.087l-3.818.674-1.617.27-6.572 1.08-.54.086-5.55.852m154.897-14.183l-1.385-1.697\n          2.8-2.919-1.504-2.612-.512-2.976-.473-2.6-1.256-7.108 5.809-1.218.628-.134 6.69-1.576\n          4.997-1.209.003.01.436-.091 4.12-.658 1.535 5.113.4 1.536.204.782.668 3.357-.22 1.729m-38.627 8.927l5.182 1.797\n          2.044.615.283.111 4.83 1.493m-633.343-24.54l-3.814 14.78-6.881 26.671-1.34 4.987-.672 2.4-.66\n          2.758-.247.961-.213.824-.274 1.268.992 1.531 3.516 5.257 2.722 4.06 1.868 2.814 7.968 12.022 6.558 9.915 7.494\n          11.277 14.59 21.925 2.785 4.261 12.018 18.02 1.407-2.341.37-3.548-.643-3.43.803-2.1-.417-1.775\n          1.247-2.952-.795-2.336.233-1.988 2.082-.566 3.18.504 2.099 2.978 1.302.057 2.133-2.847 2.21-12.064.56-2.914\n          16.732 3.112 5.22.928 16.416 2.765 9.69 1.52 10.938 1.78 13.965 1.97 1.253-9.072 1.073-7.388.702-5.087.638-6.518\n          2.341-16.18.338-2.447.42-3.039 1.45-10.49 1.112-8.05.894-6.463m415.84 16.214l-4.022.72-2.165.372-7.056\n          1.166-1.411.232-.735-4.475-.116-1.017-.488-2.66-.68-4.452-.29-1.45-.494-3.005m-302.261 26.912l9.09.57 1.22.058\n          8.026.437.254.012 7.725.374.204.009 7.829.321 6.356.218 1.577.052 4.831.147 3.154.087 3.255.071 4.832.117\n          1.577.032 6.41.117 6.41.077 1.578.015 4.834.042 3.205.022 3.206.004 3.154-.003\n          6.36-.019.408-.003-1.43-.689.297-1.419-2.3-2.79-.05-.061-2.195-4.87-.76-1.161m156.781 18.469l-.655\n          1.484.001.01.388 2.412 1.174.688-.057 1.282-3.02.904-2.37 1.608-2-.63-1.473.34.449 2.62.027 1.179-2.26\n          1.789-.388 1.224-1.27 2.289-.717-.33-1.385 2.247-.333 3.285-.714.208-3.896-.551-1.239-2.358-1.806 1.334-.274\n          1.453-.039 2.233-1.136.215-.842 1.6-2.579-2.699-2.274 1.5-1.079\n          2.504-3.054-1.14-.503-.32-2.263-.607-.728.676-1.515-1.076.027 2.683-1.312-1.156.001.01-3.293.213.457\n          1.66-1.809.396-1.675 2.65.51 1.697 1.158 1.225-.265.622-2.858.611-1.082 1.002-.818-.31.002.03-.846.667-.332\n          2.496 1.433 2.02-.83 1.58-1.18-.141-5.485-2.344-.104.038-1.196.312-2.013 2.95.59 1.542-1.865-1.542-.82\n          1.175-.99-.479-1.912-3.878-.003-1.584v-.01l.812-1.254-1.688-3.042-.007-.1-.106-2.329-2.219-.906-.17-.973-2.688-1.742-1.271.64-.942-1.605-3.225-2.165-.67-.69-1.73-1.834.135-2.981.936-2.624.042-.165.992-2.496.129-2.129.633-.658.107-.788-2.513-1.297-2.574-.67-1.141\n          1.741-1.865-.949-1.18-5.401-.692-1.352-2.514-1.79-1.428-.787-2.195-2.776-1.92-1.516-.936-1.373-1.045-1.541-.093-1.922-.834-1.47-.36-3.286.06-.905.996-2.49m205.291\n          1.867l-3.386-1.667-1.99.033-1.116-.864.627-1.878-1.815-1.232-1.63-.042-.542.178-2.13-2.898-1.138-1.028.64-1-2.72.214-2.43-1.01-1.039\n          1.66-.962-.139-1.444 2.578-2.782.166-2.277-1.342-1.733 3.918-1.5-.522-2.375 3.337-2.637 2.8-1.528-9.591\n          1.157-.204 6.481-1.191 1.709-.312 5.98-1.087.553-.103 3.412-.646 8.782-1.673.152-.02 3.407-.678 3.002-.615\n          2.953-.602 3.048-.649 4.6-.962.05-.01 1.4-.296 4.792-1.036 2.232-2.712h0l.243-.084 2.272.124m10.26\n          23.897l-3.605.79-5.007.952-.505-1.84-.4-1.353-.975-3.52-1.657-5.704-.512-1.878-.251-.92-.374-1.484-1.72-6.268m-158.763-14.05l4.1-.393\n          4.098-.427 2.27-.236 3.803-.384 1.727-.188 5.08-.575 1.281-.145 5.127-.596.388 1.165.367 3.102.28 1.942.344\n          2.902.039.331.584 4.931.148 1.256.43 3.627.344 2.914.486 4.1.095.804.575 5.721.144 1.655.42 3.56.353\n          2.976.05.86.43 4.08.441 3.73.83-.873 2.054 1.121 1.641-.596 2.83 1.051 1.57 2.602.11.874 2.699.734 2.113-.208\n          3.192 2.07h0l.875-.104 1.538-1.428 3.907 1.063-.004-.03 1.597-.186 1.523-2.253.001.01 1.926-.817 1.556 3.28\n          2.277.908 1.252 1.429.36 3.274h0l-.238 2.04 2.814 3.077-.275.296 1.436 1.523 1.5 1.943.77 1.29 2.814 1.8\n          2.277-.07.643.386-.859.67 1.291 2.225 3.05 1.826 2.702.184 2.547-2.894 2.283 1.612 3.375-1.661\n          1.716-1.3-.35-1.514.005.03 1.469.83 3.36-2.651.753 1.005 2.285-2.001-.59-.98 1.36-1.44-1.29-1.016 1.3-3.669\n          1.3-1.74 1.036-2.333.47-2.526 1.255-1.624-.329-.683 1.339-2.647.047-3.072 1.72.502 1.17 1.554 2.453.44\n          1.064-1.443 1.452-5.715.57-1.79 2.075 1.29.75-2.515.907-.496 1.965-3.278.396-.692\n          1.197-1.727-.529-1.705.297-3.991 1.925 1.08 3.17 1.819 3.354 1.912.886-3.803m10.256 5.907l-.404-.435 1.501-.913\n          1.594 1.103-1.21 1.837M241.8 31.106l-1.93 9.01-1.152 5.167-.918 4.289 1.839 4.635 1.12 1.295.002 1.976-1.011.601\n          1.375 1.654-1.87.697 2.284 1.783.624 1.485 1.965.886-.031 1.287 1.22 1.35 1.11 3.284.993.884-.138 1.378 2.987\n          2.913.667 2.089 3.402.17-4.34 11.763.863 2.14-2.72 1.712.688 1.352-1.426 2.621 1.223.108 1.239 2.226 6.086-3.298\n          1.298 1.952-.227 3.724.564 2.854 2.413 4.823-.942 1.44 1.447 3.385 1.341-.469 1.557 2.052.584 3.978-.207 1.414\n          2.2 1.796.829-1.926 4.024.803 1.027.772.638-1.441 1.444-.515 1.814 1.26 3.237-.276.441 1.114 2.806-.306\n          1.451-.015.959-2.603 1.348-.584 1.677 2.726-.271.781 2.087 2.332m470.048 93.837l-.002-.01m27.246 11.017l-3.392\n          1.137m-284.978-6.133l1.541 1.77 2.351.737.656-.624 1.648 1.44-2.462 3.742-.7 1.708 1.97 2.137 1.105 2.419 1.718\n          1.7 2.48.715-.09.863.019 1.306.054 3.717.03 2.046.02 4.923.025 1.67.09 6.2-.046.436.048 6.868.005.365.132\n          5.458-.046.477.078 5.317.015\n          1.084-5.725.071-.955.01-4.983.04-1.697.01-3.87.013-2.651.004h-.53l-7.741-.011-3.34-.033-5.832-.058-4.666-.054-5.036-.087-4.559-.073-3.498-.082-2.915-.096-6.73-.206-6.73-.23-1.218-.044-6.832-.322-1.271-.064-8-.327-4.608-.202-1.8-.074-7.203-.363-6.989-.375-.21-.034m186.99\n          8.787l1.155-2.609 1.26 1.2.945-1.732-.46-1.206 1.076-1.347-.824-.336.926-2.667-.528-.672m-77.981\n          66.442l.075-5.68v-.01l.035-4.692.013-5.987.042-4.168.046-3.855.08-8.38v-.031l-.006-.324-.669-4.534-.36-2.272-.96-6.435-.179-1.142-.95-6.345-.046-3.17-.027-1.863-.064-4.385m.137\n          9.418l8.059-.12 3.148-.067 4.162-.1 4.002-.097.32-.02 6.563-.191 1.227-.041 3.573-.137 5.654-.217.427-.018\n          6.664-.308 3.308-.124.64-.01 4.157-.228 5.064-.28 3.09-.172 5.33-.305.958-.058 1.233 1.76.331 1.866-1.754\n          1.996-2.553 4.028 1.34-.09 4.877-.363 3.803-.298 1.035 1.778-1.782.778.976.9-3.61 1.786 1.53 1.92-1.362.716.717\n          1.05-1.322-.352-.742 1.122.235 2.023-.154.142-.591-1.657-.812.892 1.085.876-1.25 1.74 1.495 1.317-.047\n          1.868-1.35.175-.492 1.763-1.432.665 1.073 1.506-.866 1.035-1.55.6-.934-1.03.272 3.723-1.746 1.073.29 2.182.064\n          2.082-2.692 1.002.284 1.16-1.6 1.95-1.345-.444-.16 2.185.001.01.92 1.723-2.858 1.324 1.148.81-.77 1.164 1.396\n          1.273-2.415.43-1.058 2.076 1.393 1.214-1.465.681.308.602-.248 1.691 1.531 1.662 1.086 3.756-1.612.154 1.077\n          1.39-.619\n          1.022.007.132-1.507.055-2.679.131-.39.02-9.433.37-10.218.276-4.133.076-3.853.097-3.908.108-.502.013-4.411.099-.168.004-3.518.076-.097-4.744-.164-5.27-2.953-.66-2.314.91-1.581-1.752-4.005-1.164-1.837-.765-1.628-2.154-1.271-.048-1.67-1.359-.942-.477-1.423\n          1.598-3.702-.18-.17-.818-3.033 1.123-1.325.639-3.647-.2-1.828 1.856-2.713.477-3.86-2.254.614-.946-.991-.35-1.834\n          1.472-1.49-.407-.975-1.88-.167.11-1.18 1.918-1.05.11.034 1.749-1.656-.263-.185-2.923-2.565\n          1.754-1.268-.23-.417-1.604-1.22.273-1.903-1.66-2.809\n          2.535-1.697-.802.534-1.768-2.089-.378-.767-2.666-.508.524-2.953-.859-.97\n          1.361-.892.371-1.935-1.831-2.273.542-2.92-1.746-3.682-.17-.198-2.303-2.443-2.381-.496\n          1.591-1.081-.454v-.01l-1.52-.471-1.838.678-2.151-2.494-1.26-1.377-1.051.26h0l.092-3.499.226-5.367.12-2.85.19-4.51.156-3.691.207-4.936.139-3.287.299-8.369-8.052-.362-6.13-.307-1.866-.099-7.993-.45-6.073-.383-1.97-.127-12.46-.864m399.628-28.39l.626-.133m.417-.09l.365-.078m-2.138.458l.47-.1m-112.8\n          18.415l3.022-.326 7.141-.893 2.27-.325 3.272-.46 4.64-.697.738-.107 1.427-.189 4.637-1.067 2.642-.349-.354.505\n          4.781-.478 6.675-.807.956-.102 3.321-.508 2.495-.277 5.707-.8.369-.063 4.63-.772 2.945-.503.63-.11 1.837-.335\n          1.838-.327 1.156-.206 4.986-.904.945-.173 4.035-.768 1.934-.393 4.036-.765 2.146-.423 1.934-.395 6.86-1.329\n          1.93-.417 3.615-.69-.03-.148 5.492-1.099.73-.152 2.559-.535 2.766-.584 1.304-.277m-89.487-2.73l-4.303\n          5.167-.048.037-3.246 2.299-.194.14-1.862 1.563-.038 1.631-1.922 1.568.054 1.547-2.743 1.104-.616 2.17-4.6\n          2.14-3.011\n          1.612-3.722.736-1.168.108-3.232.365-.476.059-7.646.714-.106.012-2.831.109-4.471.3-.264.04-2.102.378-5.198.51-2.715.168-3.467.149-3.042.097-2.195.536-2.997.01-4.444.528-.741.09-3.286.335-4.505.466-.795.08-5.586-.305.497\n          3.373-6.442.464-.427.024-4.418.321-.16.002-.106.018-7.613.545-1.059.165-.957.076m-10.557 29.05l8.858-.538\n          1.194-.1 4.348-.267 2.334-.176 2.824-.205 2.93-.239.543-.041 6.134-.48.271-.021 2.442-.2 3.185-.458 5.807-.461\n          5.754-.44.217-.02 5.706-.388.759-.074 7.043-.703.054-.005 6.775-.658 3.905-.352 2.006-.191 1.622-.192 1.512-.201\n          4.323-.538 2.488-.292.54-.074 2.377-.294 4.486-.547-.072-4.13.83-1.245\n          1.983.118.971-.969-.173-2.232.788-1.1.115.047 2.438-2.242 1.643-.357 2.425-.206 3.31-2.954-.053-.392 2.432-1.72\n          1.758-.271.561-3.011 1.179.275.798-1.665 2.14-.977.086 1.368 1.513-.43 1.08-1.934-.004-.02 2.64-1.99\n          2.216.699.743-.478 1.037-2.867.15-.442 1.053-1.284 1.926-.137-.467-.943.182-3.787M198.157 334l3.109-.113\n          1.503-2.708-.358-2.23-2.167-.554-.56-1.192 1.048-2.406-.58-1.65.42-1.811 1.643-.291\n          1.943-1.809.965-2.6.236-4.341 1.887-1.586.273-1.1 2.96-1.08\n          2.243-2.036-2.487-3.316-.992-5.183-1.919-3.524.517-2.321m547.48\n          24.196l-1.36-.981-7.534-5.398-.06-.02-6.724-4.935-.19-.131-3.957-2.647-3.612.57-5.888.86-3.671.545-3.563.528-.081-2.21-1.054-1.06-1.191-1.244-2.001.923-.145-1.954-4.447.402-.592.082-6.06.62-1.566.174-1.46.156-3.678.369-2.083.394-3.21\n          1.34-2.597 1.828-1.962.508-1.599.752-1.44.708m-72.792\n          94.999l-.807-6.471-.565-4.9-.287-2.158-.819-5.963-.56-4.897-.46-3.653.18-6.284.046-1.541.1-5.088.087-6.618.017-1.176.106-5.6.07-4.637.117-4.003.125-5.922.011-.528.131-4.444.053-2.693-.02-2.24.223-5.886-1.735-1.805m148.822\n          1.527l-.25-.138M523.674 419.01l-1.447-2.257 1.141-.97\n          2.065-3.533.145-3.61-1.02-1.574.43-1.358.675-.69-.737-1.912.955-.999 1.824-5.216-.297-2.63\n          1.02-.398-.947-1.234.129-1.655-.739.18-.269-1.594-1.16-.727.186-1.767-2.646-3.493.575-2.19-1.422-2.638-2.207-2.503-.48-4.044-.075-3.68-.116-5.648-.073-3.531-.054-2.594m-133.783-78.468l-.747\n          9.4-.586-.044-.567 8.365-.44 5.937-.165 2.21-.666 8.242-.319 4.299-.289 3.894-.605 8.148-.015.202-.72 8.947-.465\n          4.768-.31 3.42-.71 8.028-.609 8.181-.606 8.146-.122\n          1.638-4.118-.312-6.204-.492-4.06-.336-.676-.057-12.96-1.154-1.07-.1-16.939-1.742-5.964-.621-3.77-.388-.663 1.842\n          1.62 2.341m53.642-169.149l6.65.538 2.701.213 10.107.748.5.035 7.91.528-.303 4.755-.062.97-.309 4.836-.109\n          1.707-.414 6.505-.464 8.077-.007.11-.47 8.19-.104 1.627-.419 6.57-.099 1.557-.415 6.51-.007.122-.576 9.87-.113\n          1.77-.306 4.801-.473\n          7.44-14.115-1.092-1.27-.094-13.589-1-16.846-1.515-1.002-.097-7.28-.738-4.273-.435-6.856-.711-13.89-1.73-.895-.108-13.153-1.64-9.721-1.308L294\n          287.52l-2.688 19.46-.98 7.103-2.171 14.906-1.466 10.607-1.11 8.03-.903 6.536-2.81\n          20.334m383.503-65.37l2.866-.336 1.891-.238 1.026-.13 5.819-.857 1.026-.136 5.591-.905.106 1.18-1.795 1.367-1.267\n          3.273.288.502-.048.058 3.952 2.272.925.7.952.084 1.965.197 1.796 2.945.7 1.433 2.748 3.308.588.998.059.023 4.401\n          2.277 1.336 1.878 2.072 1.535 1.46.775.255.207 1.504 1.053.17 2.272 1.59 1.6 1.624.685.004.776 2.437.815\n          1.299.74 2.427 3.64.534 1.623.653 2.748 1.775.449.001.01 1.722 1.548 1.308 2.152.043 2.086.765\n          1.952m-75.922-44.23l.636 2.292 1.194 4.356.182.641.35 1.172 1.259 4.378 1.084 3.764.573 2.143.295 1.147 1.293\n          4.573.854 3.116.281 1.005 1.518 5.478.1.395 1.285 4.355.987 2.223 1.19 2.484 1.438 1.681.736 2.423-.453.987\n          1.987.976-.486.697-1.921 2.05.208 1.305-.014 1.362-.8 1.949.127 2.105.264.314 1.372 2.479.398 1.951-.175\n          3.954.087 2.746 1.323 1.488.561\n          1.353-7.677.933-.17.02-8.479.987-2.45.245-3.192.328-4.733.452-1.543.11-6.048.546-6.9.658-.355 2.496 1.867 2.197\n          2.114 1.042-.138 3.586m37.704-13.6l2.85 5.106 7.755-.518 1.552-.1 3.16-.223 1.264-.089 4.197-.285 2.127-.145\n          4.084-.277.23-.011.52-.019 2.762-.19 7.194-.5 1.67-.115 2.013-.155.634-.04 3.284-.223.632 3.128\n          2.552.296.134-3.82-.93-1.57.03-2.546 1.763-1.025 5.023 1.337M563.851 355.42l-.069 1.954 1.263-1.571.517\n          1.328-1.211 1.507.03 1.696 1.36.223-1.319 1.675 1.745 1.132-.38.272-.655 1.469 2.41.864-.557 1.17\n          1.495.547-.971.84-.126 1.884-2.098-.133-.545 1.502 1.756.061.286.046.006.12-.583 1.858-1.698 1.127-.875\n          1.77-1.455.404.49 1.893-.949.339-.236 2.16-1.87.18 1.75.864-1.674.736.13 1.536-.988.843 1.083 2.388-2.146.564\n          1.078 1.058-.563 1.427 1.072.887-1.086 1.31 7.324-.334 1.888-.098 3.717-.218 4.06-.226.344-.02 3.201-.197\n          1.373-.083 6.8-.456 1.716-.113-1.423 6.384 1.332 2.734 1.336.98.963 3.158 2.098 1.893m12.756-218.607h0l.404\n          4.51.282 3.162.22 2.468.263 2.931.457 5.119.413 4.616.023.262.502 6.184.393 4.975.514 5.18.218 2.44.218\n          2.43-.877 1.746-.189 1.948-.205.019 1.2 1.866.868 2.77.001.01.032.932.33 3.123-1.61 2.38.204 1.131-1.4.692.154\n          1.177-2.981 3.621-.343-.347.145.486 1.15 1.203-1.255 2.516.178 2.74-1.152.046.053.016 1.032 1.641M537.473\n          99.632l-1.156-.014h0l.18 4.587.188 4.83-.642 2.68-4.582 2.393-1.624 3.164-.51 1.612.042 1.253 1.46.122 1.668\n          2.04-1.12 3.02-.085 1.621.032 6.5-.355 2.165.971.58 2.426 2.62 3.21.423.97 1.583 2.18.778.049.008 2.159\n          1.298.974 2.587 4.166 2.955 1.813.69 1.999 2.473.496 2.215.002.04-.091 2.052.833 2.138m147.965 12.904l.39 2.373\n          1.069 6.503.03.19 1.088 6.615.026.16.687 4.181.196.88.6 3.962-1.87 1.382 1.306 1.735-.19 1.652.657 1.513-.772\n          2.515-.215.578-.028 2.364.069 2.337-.77 1.303.233 2.414-1.227 2.36-1.115 1.46-.923 1.704-1.073 1.43-2.138\n          1.286-1.05-1.077-1.578 1.554.004 1.383-1.543.112-.502 1.151-.307.723.338 1.547.237 3.293-1.922\n          1.118v-1.045l-1.744-1.552-1.195 1.446-.245 2.237-.941 1.07 1.136 3.467-.575.37-1.002.32-.195 2.64-2.483\n          1.001-1.313.003m145.315-92.765l-1.504-.823-1.87-3.57-1.685-.183-4.023 1.232m-576.952 18.959l-3.529 18.366-3.239\n          16.317-.749 3.897-1.291 6.722-3.082 16.032-.422 1.92-1.46 7.868-1.986 10.057-2.152 11.191m361.03 31.453l.155\n          3.045-.981.564 1.246.97-2.402.193 1.048 1.219.606 1.024-1.23.905-.272 1.58");
			attr(path0, "class", "svelte-7v0gex");
			attr(g2, "style", g2_style_value = `stroke-width:${1.5 / /*$zoom*/ ctx[20]}px`);
			attr(g2, "transform", g2_transform_value = `translate(${/*width*/ ctx[4] / 2},${/*height*/ ctx[3] / 2}) scale(${/*$zoom*/ ctx[20]}) translate(${-/*$coords*/ ctx[21].x},${-/*$coords*/ ctx[21].y})`);
			attr(path1, "d", "M-1,1 l4,-4\n                 M0,8 l8,-8\n                 M3,5 l4,-4");
			set_style(path1, "stroke", "gray");
			set_style(path1, "stroke-width", "1");
			attr(pattern, "id", "diagonalHatch");
			attr(pattern, "patternUnits", "userSpaceOnUse");
			attr(pattern, "width", "8");
			attr(pattern, "height", "8");
			set_style(pattern, "position", "absolute");
			set_style(pattern, "opacity", "0");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "width", "100%");
			attr(svg, "height", "100%");
			attr(svg, "viewBox", svg_viewBox_value = `0 0 ${/*width*/ ctx[4]} ${/*height*/ ctx[3]}`);
			attr(svg, "class", "svelte-7v0gex");
			attr(div1, "class", div1_class_value = "" + (null_to_empty(`nh-map ${/*classes*/ ctx[2]}`) + " svelte-7v0gex"));
		},
		m(target, anchor) {
			mount_component(tabs, target, anchor);
			insert_hydration(target, t0, anchor);
			insert_hydration(target, div1, anchor);
			if (if_block0) if_block0.m(div1, null);
			append_hydration(div1, t1);
			if (if_block1) if_block1.m(div1, null);
			append_hydration(div1, t2);
			append_hydration(div1, div0);
			append_hydration(div0, svg);
			append_hydration(svg, rect);
			append_hydration(svg, g2);
			append_hydration(g2, g0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(g0, null);
			}

			append_hydration(g2, g1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(g1, null);
			}

			append_hydration(g2, path0);
			append_hydration(svg, pattern);
			append_hydration(pattern, path1);
			append_hydration(div1, t3);
			if (if_block2) if_block2.m(div1, null);
			append_hydration(div1, t4);
			if (if_block3) if_block3.m(div1, null);
			insert_hydration(target, t5, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert_hydration(target, if_block4_anchor, anchor);
			current = true;

			if (!mounted) {
				dispose = [
					listen(rect, "click", /*resetZoom*/ ctx[27]),
					listen(div0, "mousemove", /*positionHover*/ ctx[31]),
					listen(div0, "mouseleave", /*mouseleave_handler*/ ctx[42])
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			const tabs_changes = {};
			if (dirty[0] & /*dataPoints*/ 32) tabs_changes.items = /*dataPoints*/ ctx[5].map(func);
			if (dirty[0] & /*customTabClass*/ 256) tabs_changes.customClass = /*customTabClass*/ ctx[8];

			if (!updating_activeTab && dirty[0] & /*activeTab*/ 8192) {
				updating_activeTab = true;
				tabs_changes.activeTab = /*activeTab*/ ctx[13];
				add_flush_callback(() => updating_activeTab = false);
			}

			tabs.$set(tabs_changes);

			if (/*hoveredEntity*/ ctx[16]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(div1, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*selected*/ ctx[15]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*selected*/ 32768) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_5(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t2);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty[0] & /*width*/ 16) {
				attr(rect, "width", /*width*/ ctx[4]);
			}

			if (!current || dirty[0] & /*height*/ 8) {
				attr(rect, "height", /*height*/ ctx[3]);
			}

			if (dirty[0] & /*counties, selectedDataPoint, getPercentileClass, handleEntityHover, isDev*/ 1086849025) {
				each_value_2 = /*counties*/ ctx[19];
				each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key, 1, ctx, each_value_2, each0_lookup, g0, destroy_block, create_each_block_2, null, get_each_context_2);
			}

			if (dirty[0] & /*states, selectedDataPoint, getPercentileClass, updateZoom, handleStateClick, selected, disableStateZoom, ensureStateData, handleEntityHover*/ 1904247811) {
				each_value_1 = /*states*/ ctx[1];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(g1, null);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (!current || dirty[0] & /*mapStrokeColor*/ 2048 && path0_style_value !== (path0_style_value = /*mapStrokeColor*/ ctx[11]
			? `stroke: ${/*mapStrokeColor*/ ctx[11]};`
			: '')) {
				attr(path0, "style", path0_style_value);
			}

			if (!current || dirty[0] & /*$zoom*/ 1048576 && g2_style_value !== (g2_style_value = `stroke-width:${1.5 / /*$zoom*/ ctx[20]}px`)) {
				attr(g2, "style", g2_style_value);
			}

			if (!current || dirty[0] & /*width, height, $zoom, $coords*/ 3145752 && g2_transform_value !== (g2_transform_value = `translate(${/*width*/ ctx[4] / 2},${/*height*/ ctx[3] / 2}) scale(${/*$zoom*/ ctx[20]}) translate(${-/*$coords*/ ctx[21].x},${-/*$coords*/ ctx[21].y})`)) {
				attr(g2, "transform", g2_transform_value);
			}

			if (!current || dirty[0] & /*width, height*/ 24 && svg_viewBox_value !== (svg_viewBox_value = `0 0 ${/*width*/ ctx[4]} ${/*height*/ ctx[3]}`)) {
				attr(svg, "viewBox", svg_viewBox_value);
			}

			if (/*showSidepane*/ ctx[9]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_2(ctx);
					if_block2.c();
					if_block2.m(div1, t4);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*nationalInfo*/ ctx[6]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_1(ctx);
					if_block3.c();
					if_block3.m(div1, null);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (!current || dirty[0] & /*classes*/ 4 && div1_class_value !== (div1_class_value = "" + (null_to_empty(`nh-map ${/*classes*/ ctx[2]}`) + " svelte-7v0gex"))) {
				attr(div1, "class", div1_class_value);
			}

			if (/*componentEmbedId*/ ctx[12] || debugEmbedId) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[0] & /*componentEmbedId*/ 4096) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(if_block4_anchor.parentNode, if_block4_anchor);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(tabs.$$.fragment, local);
			transition_in(if_block1);

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(if_block4);
			current = true;
		},
		o(local) {
			transition_out(tabs.$$.fragment, local);
			transition_out(if_block1);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(if_block4);
			current = false;
		},
		d(detaching) {
			destroy_component(tabs, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div1);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}

			destroy_each(each_blocks, detaching);
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (detaching) detach(t5);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(if_block4_anchor);
			mounted = false;
			run_all(dispose);
		}
	};
}

let debugEmbedId = '';
const func = d => d.tab;

function instance($$self, $$props, $$invalidate) {
	let $zoom;
	let $coords;
	let { stateSlug = '' } = $$props;
	let { states } = $$props;
	let { classes = '' } = $$props;
	let { height = 500 } = $$props;
	let { width = 960 } = $$props;
	let { selectedDataPoint = {} } = $$props;
	let { dataPoints } = $$props;
	let { nationalInfo } = $$props;
	let { colorPrefix = 'p' } = $$props;
	let { customTabClass = 'tab-nav--pills' } = $$props;
	let { showSidepane = false } = $$props;
	let { disableStateZoom = false } = $$props;
	let { mapStrokeColor = '' } = $$props;
	let { componentEmbedId } = $$props;
	let isModalOpen = false;
	const isDev = process.env.componentType === 'browser' && window && window.location.hostname.includes('localhost');
	if (!selectedDataPoint && dataPoints[0]) selectedDataPoint = dataPoints[0];
	let selected;
	let hoveredEntity;
	let hoverX, hoverY;

	// if used to show just a specific state
	if (stateSlug) {
		selected = stateSlug;
	}

	let egKey = '';

	onMount(() => {
		const egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
	});

	const getPercentileClass = (type, number) => {
		let i = Math.ceil(number / 0.11111111);
		if (i === 0) i = 1;
		if (i < 0) i = 0;
		if (type === 'bg') return `${colorPrefix}${i}-bg`;
		if (type === 'fill') return `${colorPrefix}${i}-fill`;
		if (type === 'text') return `${colorPrefix}${i}-fill`;
	};

	let errors;
	const graphql = getGraphqlClient();

	const getCounties = gql`
    query state($state: String!) {
      __typename
      result: allCountyForMaps(condition: { stateSlug: $state }) {
        nodes {
          name
          stateSlug
          countySlug
          rate12Month
          electricityBill12Month
          totalEmission12MonthPerCapita
          providerCount
          plantsCount
          svgPath
          rate12MonthPercentileNationalRank
          electricityBill12MonthPercentileNationalRank
          totalEmission12MonthPerCapitaPercentileNationalRank
          providerCountPercentileNationalRank
          stateName
        }
      }
    }
  `;

	let counties = [];
	const statesWithCountyData = [];
	const statesAttempting = [];

	async function ensureStateData(slug) {
		if (statesAttempting.includes(slug) || statesWithCountyData.includes(slug)) return;
		statesAttempting.push(slug);
		const r = await graphql(getCounties({ state: slug }), { 'eg-key': egKey });

		if (r.errors) {
			errors = r.errors;
			console.error(r.errors);
			statesAttempting.splice(statesAttempting.indexOf(slug), 1);
		}

		if (r.data && r.data.result && r.data.result.nodes) {
			$$invalidate(19, counties = [...counties, ...r.data.result.nodes]);
			statesWithCountyData.push(slug);
		}
	}

	let coords = spring({ x: width / 2, y: height / 2 }, { stiffness: 0.08, damping: 0.9 });
	component_subscribe($$self, coords, value => $$invalidate(21, $coords = value));
	let zoom = spring(1, { stiffness: 0.08, damping: 0.7 });
	component_subscribe($$self, zoom, value => $$invalidate(20, $zoom = value));

	function resetZoom(event) {
		set_store_value(zoom, $zoom = 1, $zoom);
		set_store_value(coords, $coords = { x: width / 2, y: height / 2 }, $coords);
		$$invalidate(15, selected = false);
		$$invalidate(16, hoveredEntity = false);
	}

	function updateZoom(event) {
		if (!event.detail.bb || !event.detail.zoom) return;

		set_store_value(
			coords,
			$coords = {
				x: event.detail.bb[0],
				y: event.detail.bb[1]
			},
			$coords
		);

		set_store_value(zoom, $zoom = event.detail.zoom, $zoom);
	}

	function handleStateClick(event, state) {
		if (disableStateZoom) {
			if (state.permalink) window.location = state.permalink;
			return;
		}

		$$invalidate(15, selected = state.slug);
	}

	function handleEntityHover(event, entity) {
		$$invalidate(16, hoveredEntity = entity);
	}

	function positionHover(event) {
		let el;

		if (event.target.classList.contains('nh-map')) {
			el = event.target;
		} else {
			el = event.target.closest('.nh-map');
		}

		const pRect = el.getBoundingClientRect();
		$$invalidate(17, hoverX = event.clientX - pRect.left);
		$$invalidate(18, hoverY = event.clientY - pRect.top);
	}

	function handleTabChange(tab) {
		$$invalidate(0, selectedDataPoint = dataPoints.find(d => d.tab === tab));
	}

	let activeTab = selectedDataPoint.tab;

	const FORMATTERS = {
		natgasProcessingPlants: item => item.natgasProcessingPlantsValue > 0
		? `${item.name} has a total of ${item.natgasProcessingPlantsValue} natural gas processing plants.`
		: `We don't have data for ${item.name}.`,
		natgasAverageResidentialRate: item => `${item.name}'s residential natural gas rate is $${roundToMax2Decimals(item.natgasAverageResidentialRateVal)} per CCF.`,
		natgasAverageCommercialRate: item => `${item.name}'s commercial natural gas rate is $${roundToMax2Decimals(item.natgasAverageCommercialRateVal)} per CCF.`,
		natgasAverageIndustrialRate: item => `${item.name}'s industrial natural gas rate is $${roundToMax2Decimals(item.natgasAverageIndustrialRateVal)} per CCF.`,
		solarPotential: item => `${item.name} is able to generate up to ${item.kwhPerYear} kWh AC per year. An average home here needs about ${item.avgNeededKwhYear} kWh.`,
		solarInstallers: item => `We have registered ${item.solar_installers} installers for ${item.name}.`,
		solarPricing: item => `The price for a 5 kW system in ${item.name} is $${roundFormat(item.avgPricePerWatt * 5000)}.`,
		rate12MonthPercentileNationalRank: item => `${item.name}'s electricity costs on average ${formatRate(item.rate12Month)}¢/kWH`,
		electricityBill12MonthPercentileNationalRank: item => `The average electricity bill in ${item.name} is $${Number(item.electricityBill12Month.toFixed(2)).toLocaleString()}/mo.`,
		totalEmission12MonthPerCapitaPercentileNationalRank: item => `Over the past 12 months power consumption in ${item.name} has resulted in ${Number(item.totalEmission12MonthPerCapita.toFixed(2)).toLocaleString()}kg of CO2 emissions per capita.`,
		providerCountPercentileNationalRank: item => {
			return `Within ${item.name} we have recorded ${item.providerCount} electric providers.`;
		}
	};

	const nationalFormatters = {
		rate12MonthPercentileNationalRank: rate => `${formatRate(rate)}¢/kWH`,
		electricityBill12MonthPercentileNationalRank: bill => `$${Number(bill.toFixed(2)).toLocaleString()}/mo.`,
		totalEmission12MonthPerCapitaPercentileNationalRank: emission => `${Number(emission.toFixed(2)).toLocaleString()}kg of CO2 emissions per capita.`,
		providerCountPercentileNationalRank: providers => `${Number(providers).toLocaleString()} providers`
	};

	function tabs_activeTab_binding(value) {
		activeTab = value;
		$$invalidate(13, activeTab);
	}

	const click_handler = () => resetZoom();
	const mouseover_handler = (county, e) => handleEntityHover(e, county);

	const click_handler_1 = county => {
		window.location = `${window.location.origin}${isDev ? `/dev` : ''}/${county.stateSlug}/${county.countySlug}-electricity/`;
	};

	const clicked_handler = (state, svelteEvent) => {
		handleStateClick(svelteEvent.detail.event, state);
	};

	const clicked_handler_1 = (state, svelteEvent) => {
		handleStateClick(svelteEvent.detail.event, state);
	}; // console.log(state[selectedDataPoint.property]);

	const hovered_handler = (state, svelteEvent) => {
		if (!disableStateZoom) ensureStateData(state.slug);
		handleEntityHover(svelteEvent.detail.event, state);
	};

	const mouseleave_handler = () => $$invalidate(16, hoveredEntity = false);

	function embedmodal_isModalOpen_binding(value) {
		isModalOpen = value;
		$$invalidate(14, isModalOpen);
	}

	$$self.$$set = $$props => {
		if ('stateSlug' in $$props) $$invalidate(34, stateSlug = $$props.stateSlug);
		if ('states' in $$props) $$invalidate(1, states = $$props.states);
		if ('classes' in $$props) $$invalidate(2, classes = $$props.classes);
		if ('height' in $$props) $$invalidate(3, height = $$props.height);
		if ('width' in $$props) $$invalidate(4, width = $$props.width);
		if ('selectedDataPoint' in $$props) $$invalidate(0, selectedDataPoint = $$props.selectedDataPoint);
		if ('dataPoints' in $$props) $$invalidate(5, dataPoints = $$props.dataPoints);
		if ('nationalInfo' in $$props) $$invalidate(6, nationalInfo = $$props.nationalInfo);
		if ('colorPrefix' in $$props) $$invalidate(7, colorPrefix = $$props.colorPrefix);
		if ('customTabClass' in $$props) $$invalidate(8, customTabClass = $$props.customTabClass);
		if ('showSidepane' in $$props) $$invalidate(9, showSidepane = $$props.showSidepane);
		if ('disableStateZoom' in $$props) $$invalidate(10, disableStateZoom = $$props.disableStateZoom);
		if ('mapStrokeColor' in $$props) $$invalidate(11, mapStrokeColor = $$props.mapStrokeColor);
		if ('componentEmbedId' in $$props) $$invalidate(12, componentEmbedId = $$props.componentEmbedId);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*activeTab*/ 8192) {
			$: handleTabChange(activeTab);
		}
	};

	return [
		selectedDataPoint,
		states,
		classes,
		height,
		width,
		dataPoints,
		nationalInfo,
		colorPrefix,
		customTabClass,
		showSidepane,
		disableStateZoom,
		mapStrokeColor,
		componentEmbedId,
		activeTab,
		isModalOpen,
		selected,
		hoveredEntity,
		hoverX,
		hoverY,
		counties,
		$zoom,
		$coords,
		isDev,
		getPercentileClass,
		ensureStateData,
		coords,
		zoom,
		resetZoom,
		updateZoom,
		handleStateClick,
		handleEntityHover,
		positionHover,
		FORMATTERS,
		nationalFormatters,
		stateSlug,
		tabs_activeTab_binding,
		click_handler,
		mouseover_handler,
		click_handler_1,
		clicked_handler,
		clicked_handler_1,
		hovered_handler,
		mouseleave_handler,
		embedmodal_isModalOpen_binding
	];
}

class ZoomableMap extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				stateSlug: 34,
				states: 1,
				classes: 2,
				height: 3,
				width: 4,
				selectedDataPoint: 0,
				dataPoints: 5,
				nationalInfo: 6,
				colorPrefix: 7,
				customTabClass: 8,
				showSidepane: 9,
				disableStateZoom: 10,
				mapStrokeColor: 11,
				componentEmbedId: 12
			},
			null,
			[-1, -1]
		);
	}
}

export default ZoomableMap;